function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Amazon } from './assets/brandSymbol/Amazon';
import { AmazonInverted } from './assets/brandSymbol/AmazonInverted';
import { Amex } from './assets/brandSymbol/Amex';
import { AmexInverted } from './assets/brandSymbol/AmexInverted';
import { BankOfAmerica } from './assets/brandSymbol/BankOfAmerica';
import { BankOfAmericaInverted } from './assets/brandSymbol/BankOfAmericaInverted';
import { CapitalOne } from './assets/brandSymbol/CapitalOne';
import { CapitalOneInverted } from './assets/brandSymbol/CapitalOneInverted';
import { Chase } from './assets/brandSymbol/Chase';
import { ChaseInverted } from './assets/brandSymbol/ChaseInverted';
import { CitiBank } from './assets/brandSymbol/CitiBank';
import { CitiBankInverted } from './assets/brandSymbol/CitiBankInverted';
import { CreditKey } from './assets/brandSymbol/CreditKey';
import { CreditKeyInverted } from './assets/brandSymbol/CreditKeyInverted';
import { Diners } from './assets/brandSymbol/Diners';
import { DinersInverted } from './assets/brandSymbol/DinersInverted';
import { DiscoverLogo } from './assets/brandSymbol/DiscoverLogo';
import { DiscoverLogoInverted } from './assets/brandSymbol/DiscoverLogoInverted';
import { Dynamics365BC } from './assets/brandSymbol/Dynamics365BC';
import { Dynamics365BCInverted } from './assets/brandSymbol/Dynamics365BCInverted';
import { Freshbooks } from './assets/brandSymbol/Freshbooks';
import { FreshbooksInverted } from './assets/brandSymbol/FreshbooksInverted';
import { Gmail } from './assets/brandSymbol/Gmail';
import { GmailInverted } from './assets/brandSymbol/GmailInverted';
import { Google } from './assets/brandSymbol/Google';
import { GoogleAds } from './assets/brandSymbol/GoogleAds';
import { GoogleAdsInverted } from './assets/brandSymbol/GoogleAdsInverted';
import { GoogleInverted } from './assets/brandSymbol/GoogleInverted';
import { MastercardLogo } from './assets/brandSymbol/MastercardLogo';
import { MastercardLogoInverted } from './assets/brandSymbol/MastercardLogoInverted';
import { Melio } from './assets/brandSymbol/Melio';
import { MelioInverted } from './assets/brandSymbol/MelioInverted';
import { Meta } from './assets/brandSymbol/Meta';
import { MetaInverted } from './assets/brandSymbol/MetaInverted';
import { Privacy } from './assets/brandSymbol/Privacy';
import { PrivacyInverted } from './assets/brandSymbol/PrivacyInverted';
import { Quickbooks } from './assets/brandSymbol/Quickbooks';
import { QuickbooksInverted } from './assets/brandSymbol/QuickbooksInverted';
import { UsBank } from './assets/brandSymbol/UsBank';
import { UsBankInverted } from './assets/brandSymbol/UsBankInverted';
import { VisaLogo } from './assets/brandSymbol/VisaLogo';
import { VisaLogoInverted } from './assets/brandSymbol/VisaLogoInverted';
import { WallsFargo } from './assets/brandSymbol/WallsFargo';
import { WallsFargoInverted } from './assets/brandSymbol/WallsFargoInverted';
import { Xero } from './assets/brandSymbol/Xero';
import { XeroInverted } from './assets/brandSymbol/XeroInverted'; // user facing only

export var brandSymbolsMap = {
  'amex-logo': {
    default: Amex,
    inverted: AmexInverted
  },
  google: {
    default: Google,
    inverted: GoogleInverted
  },
  diners: {
    default: Diners,
    inverted: DinersInverted
  },
  privacy: {
    default: Privacy,
    inverted: PrivacyInverted
  },
  'us-bank': {
    default: UsBank,
    inverted: UsBankInverted
  },
  'bank-of-america': {
    default: BankOfAmerica,
    inverted: BankOfAmericaInverted
  },
  'citi-bank': {
    default: CitiBank,
    inverted: CitiBankInverted
  },
  chase: {
    default: Chase,
    inverted: ChaseInverted
  },
  'walls-fargo': {
    default: WallsFargo,
    inverted: WallsFargoInverted
  },
  mastercard: {
    default: MastercardLogo,
    inverted: MastercardLogoInverted
  },
  visa: {
    default: VisaLogo,
    inverted: VisaLogoInverted
  },
  discover: {
    default: DiscoverLogo,
    inverted: DiscoverLogoInverted
  },
  melio: {
    default: Melio,
    inverted: MelioInverted
  },
  'xero-logo': {
    default: Xero,
    inverted: XeroInverted
  },
  'freshbooks-logo': {
    default: Freshbooks,
    inverted: FreshbooksInverted
  },
  quickbooks: {
    default: Quickbooks,
    inverted: QuickbooksInverted
  },
  'credit-key': {
    default: CreditKey,
    inverted: CreditKeyInverted
  },
  dynamics365bc: {
    default: Dynamics365BC,
    inverted: Dynamics365BCInverted
  },
  'capital-one': {
    default: CapitalOne,
    inverted: CapitalOneInverted
  },
  meta: {
    default: Meta,
    inverted: MetaInverted
  },
  amazon: {
    default: Amazon,
    inverted: AmazonInverted
  },
  gmail: {
    default: Gmail,
    inverted: GmailInverted
  },
  googleAds: {
    default: GoogleAds,
    inverted: GoogleAdsInverted
  }
};
export var BRAND_SYMBOL_SUFFIX_KEYS = {
  default: '-default',
  inverted: '-inverted'
};
/**
 * @private internal usages only
 */

export var _brandSymbolsMap = Object.entries(brandSymbolsMap).reduce((acc, _ref) => {
  var [key, value] = _ref;
  return _objectSpread(_objectSpread({}, acc), {}, {
    ["".concat(key).concat(BRAND_SYMBOL_SUFFIX_KEYS.default)]: value.default
  });
}, {});
/**
 * @private internal usages only
 */

export var _brandSymbolsInvertedMap = Object.entries(brandSymbolsMap).reduce((acc, _ref2) => {
  var [key, value] = _ref2;
  return _objectSpread(_objectSpread({}, acc), {}, {
    ["".concat(key).concat(BRAND_SYMBOL_SUFFIX_KEYS.inverted)]: value.inverted
  });
}, {});
export var _brandSymbolsNameMap = Object.keys(brandSymbolsMap).reduce((acc, key) => _objectSpread(_objectSpread({}, acc), {}, {
  [key]: {
    default: "".concat(key).concat(BRAND_SYMBOL_SUFFIX_KEYS.default),
    inverted: "".concat(key).concat(BRAND_SYMBOL_SUFFIX_KEYS.inverted)
  }
}), {});
export var brandSymbols = brandSymbolsMap;
/**
 * @private internal usages only
 */

export var _brandSymbols = _brandSymbolsMap; // user facing only

/**
 * @private internal usages only
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
//# sourceMappingURL=brandSymbol.js.map